// extracted by mini-css-extract-plugin
module.exports = {"modal":"CreateNewMasterComponent_modal__2pzt6","wrapper":"CreateNewMasterComponent_wrapper__2gxpl","button":"CreateNewMasterComponent_button__1aiwG"};